// import components below
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const CreateNewPatientHeader = () => {
  return (
    <div className='createNewPatientHeader'>
      <PageHeaderUI>
        <h4>Admission Module</h4>
        <p>Dashboard / Admission / Create New Patient</p>
      </PageHeaderUI>
    </div>
  );
};

export default CreateNewPatientHeader;
